// Imports
import ___CSS_LOADER_API_SOURCEMAP_IMPORT___ from "../../../node_modules/css-loader/dist/runtime/sourceMaps.js";
import ___CSS_LOADER_API_IMPORT___ from "../../../node_modules/css-loader/dist/runtime/api.js";
var ___CSS_LOADER_EXPORT___ = ___CSS_LOADER_API_IMPORT___(___CSS_LOADER_API_SOURCEMAP_IMPORT___);
// Module
___CSS_LOADER_EXPORT___.push([module.id, `.navbar {
  position: relative;
  width: 100%;
  display: flex;
  align-items: center;
  justify-content: space-between;
  padding: 15px 20px;
  box-sizing: border-box;
}
  
.nav-buttons {
  display: flex;
  align-items: center;
}
  
.nav-button {
  background: #047da2;
  border: none;
  color: #ffffff;
  padding: 5px 12px;
  margin-left: 25px;
  font-family: 'Roboto', sans-serif;
  font-style: normal;
  font-weight: bold;
  font-size: 19px;
  line-height: 20px;
  cursor: pointer;
  border-radius: 32px;
  text-decoration: none;
}

.nav-buttons-container {
  display: flex;
  align-items: center;
}

.nav-button:hover {
  background-color: #035e7a;
}

.navbar-toggle {
  background: none;
  border: none;
  color: #047da2;
  font-size: 2.3em;
  cursor: pointer;
  display: none;
}

/* Estilos para responsive */
@media (max-width: 768px) {
  .nav-buttons {
    display: none;
  }

  .navbar-toggle {
    display: block;
    z-index: 12;
    color: #047da2;
  }

  .navbar-toggle.open {
    color: white;
    z-index: 110;
  }

  .mobile-menu {
    position: fixed;
    top: 0;
    left: 0;
    width: 100%;
    height: 100%; 
    background-color: #047da2;
    color: white; 
    z-index: 100; 
    overflow-y: auto; 
    padding: 20px; 
    display: flex;
    flex-direction: column;
    align-items: center; 
    justify-content: flex-start;
    padding-top: 100px;
  }

  .mobile-menu-list {
    list-style: none;
    padding: 0;
    margin: 0;
    display: flex;
    flex-direction: column;
    align-items: flex-start; 
    margin-top: 70px;
  }

  .mobile-menu-item {
    margin-bottom: 15px;
    width: 100%; 
  }

  .mobile-menu-link {
    display: block; 
    text-decoration: none;
    color: white;
    font-size: 25px; 
    font-weight: bold;
    padding: 10px 0; 
    width: 100%;
    text-align: center; 
    background: none; 
    border: none; 
  }

  .mobile-menu-link:last-child {
    border-bottom: none;
  }

  .mobile-menu .logo-container .capacita {
    color: white;
  }

}`, "",{"version":3,"sources":["webpack://./src/components/NavbarCapacita/NavbarCapacita.css"],"names":[],"mappings":"AAAA;EACE,kBAAkB;EAClB,WAAW;EACX,aAAa;EACb,mBAAmB;EACnB,8BAA8B;EAC9B,kBAAkB;EAClB,sBAAsB;AACxB;;AAEA;EACE,aAAa;EACb,mBAAmB;AACrB;;AAEA;EACE,mBAAmB;EACnB,YAAY;EACZ,cAAc;EACd,iBAAiB;EACjB,iBAAiB;EACjB,iCAAiC;EACjC,kBAAkB;EAClB,iBAAiB;EACjB,eAAe;EACf,iBAAiB;EACjB,eAAe;EACf,mBAAmB;EACnB,qBAAqB;AACvB;;AAEA;EACE,aAAa;EACb,mBAAmB;AACrB;;AAEA;EACE,yBAAyB;AAC3B;;AAEA;EACE,gBAAgB;EAChB,YAAY;EACZ,cAAc;EACd,gBAAgB;EAChB,eAAe;EACf,aAAa;AACf;;AAEA,4BAA4B;AAC5B;EACE;IACE,aAAa;EACf;;EAEA;IACE,cAAc;IACd,WAAW;IACX,cAAc;EAChB;;EAEA;IACE,YAAY;IACZ,YAAY;EACd;;EAEA;IACE,eAAe;IACf,MAAM;IACN,OAAO;IACP,WAAW;IACX,YAAY;IACZ,yBAAyB;IACzB,YAAY;IACZ,YAAY;IACZ,gBAAgB;IAChB,aAAa;IACb,aAAa;IACb,sBAAsB;IACtB,mBAAmB;IACnB,2BAA2B;IAC3B,kBAAkB;EACpB;;EAEA;IACE,gBAAgB;IAChB,UAAU;IACV,SAAS;IACT,aAAa;IACb,sBAAsB;IACtB,uBAAuB;IACvB,gBAAgB;EAClB;;EAEA;IACE,mBAAmB;IACnB,WAAW;EACb;;EAEA;IACE,cAAc;IACd,qBAAqB;IACrB,YAAY;IACZ,eAAe;IACf,iBAAiB;IACjB,eAAe;IACf,WAAW;IACX,kBAAkB;IAClB,gBAAgB;IAChB,YAAY;EACd;;EAEA;IACE,mBAAmB;EACrB;;EAEA;IACE,YAAY;EACd;;AAEF","sourcesContent":[".navbar {\n  position: relative;\n  width: 100%;\n  display: flex;\n  align-items: center;\n  justify-content: space-between;\n  padding: 15px 20px;\n  box-sizing: border-box;\n}\n  \n.nav-buttons {\n  display: flex;\n  align-items: center;\n}\n  \n.nav-button {\n  background: #047da2;\n  border: none;\n  color: #ffffff;\n  padding: 5px 12px;\n  margin-left: 25px;\n  font-family: 'Roboto', sans-serif;\n  font-style: normal;\n  font-weight: bold;\n  font-size: 19px;\n  line-height: 20px;\n  cursor: pointer;\n  border-radius: 32px;\n  text-decoration: none;\n}\n\n.nav-buttons-container {\n  display: flex;\n  align-items: center;\n}\n\n.nav-button:hover {\n  background-color: #035e7a;\n}\n\n.navbar-toggle {\n  background: none;\n  border: none;\n  color: #047da2;\n  font-size: 2.3em;\n  cursor: pointer;\n  display: none;\n}\n\n/* Estilos para responsive */\n@media (max-width: 768px) {\n  .nav-buttons {\n    display: none;\n  }\n\n  .navbar-toggle {\n    display: block;\n    z-index: 12;\n    color: #047da2;\n  }\n\n  .navbar-toggle.open {\n    color: white;\n    z-index: 110;\n  }\n\n  .mobile-menu {\n    position: fixed;\n    top: 0;\n    left: 0;\n    width: 100%;\n    height: 100%; \n    background-color: #047da2;\n    color: white; \n    z-index: 100; \n    overflow-y: auto; \n    padding: 20px; \n    display: flex;\n    flex-direction: column;\n    align-items: center; \n    justify-content: flex-start;\n    padding-top: 100px;\n  }\n\n  .mobile-menu-list {\n    list-style: none;\n    padding: 0;\n    margin: 0;\n    display: flex;\n    flex-direction: column;\n    align-items: flex-start; \n    margin-top: 70px;\n  }\n\n  .mobile-menu-item {\n    margin-bottom: 15px;\n    width: 100%; \n  }\n\n  .mobile-menu-link {\n    display: block; \n    text-decoration: none;\n    color: white;\n    font-size: 25px; \n    font-weight: bold;\n    padding: 10px 0; \n    width: 100%;\n    text-align: center; \n    background: none; \n    border: none; \n  }\n\n  .mobile-menu-link:last-child {\n    border-bottom: none;\n  }\n\n  .mobile-menu .logo-container .capacita {\n    color: white;\n  }\n\n}"],"sourceRoot":""}]);
// Exports
___CSS_LOADER_EXPORT___.locals = {};
export default ___CSS_LOADER_EXPORT___;
